<section>
    <header class="row page-header">

        <div class="col-sm-12">

            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Admin'" [routerLink]="'../'"></sp-breadcrumb>
            </sp-breadcrumbs>

            <div class="row">
                <div class="col-sm-12">
                    <a class="btn-back" [routerLink]="['../']"></a>
                    <h2 class="title">Data Import Requests</h2>
                </div>
            </div>
        </div>
    </header>

    <main>
        <sp-admin-import-request-list
            *ngIf="importRequests$ | async"
            [importRequests]="importRequests$ | async">
        </sp-admin-import-request-list>
    </main>
</section>
